package com.fireavert.properties.archive_property.data_models.requests

import kotlinx.serialization.Serializable

@Serializable
data class ArchivePropertyRequest(
    val propertyId: Int,
    val password: String
)